import { mapState } from "vuex";
export default{
 
  computed:{
    ...mapState('projects', {
      unleashValue:"unleashEnalbed"
    })
  },
  methods: {
    setValue(data){
      this.$store.commit("projects/SET_UNLEASH_FLAGED",data);
    },
    getUnleashData(){
      return this.unleashValue;
    }
  },

}